import React from 'react';
import { Picker } from 'antd-mobile';
import cx from 'classnames';
import styles from './index.less';

function getOptionLabel(options, value) {
  const option = options.find(item => item && item.value === value);
  return option ? option.label : '';
}

const MoRoleBinding = ({
  step = 1,
  servers = [],
  roles = [],
  selectedServerId,
  selectedRoleId,
  loadingServers = false,
  loadingRoles = false,
  submitting = false,
  confirmViewModel = {},
  onServerChange,
  onRoleChange,
  onNext,
  onBack,
  onConfirm,
  onClose
}) => {
  const serverPickerDisabled = loadingServers || submitting || servers.length === 0;
  const rolePickerDisabled = loadingServers || loadingRoles || submitting || !selectedServerId || roles.length === 0;
  const nextDisabled = submitting || loadingServers || loadingRoles || !selectedServerId || !selectedRoleId;

  if (step === 2) {
    return (
      <div className={styles.root}>
        <div className={cx(styles.group21, styles.visibleStateLayer)} data-name="弹窗-step2:请确认角色信息">
          <div className={styles.group22} data-name="弹窗-主体区域">
            <div className={styles.layer39} data-name="弹窗-背景底框" />
            <div className={styles.group23} data-name="所选服务器&角色展示区">
              <div className={styles.group24} data-name="角色名称展示">
                <div className={styles.layer40} data-name="服务器名展示区&背景" />
                <div className={styles.layer41} data-name="角色名： ">
                  角色名：
                </div>
                <div className={styles.layer42} data-name="角色名占位 ">
                  {confirmViewModel.roleName}
                </div>
              </div>
              <div className={styles.group25} data-name="服务器名称展示">
                <div className={styles.layer43} data-name="角色名展示区&背景" />
                <div className={styles.layer44} data-name="服务器： ">
                  服务器：
                </div>
                <div className={styles.layer45} data-name="服务器名占位">
                  {confirmViewModel.serverName}
                </div>
              </div>
            </div>
            <div className={styles.layer46} data-name="*您将领取全部奖励到以下角色， 请仔细查看您的领奖信息，以免造成不便">
              *您将领取全部奖励到以下角色，{'\n'}请仔细查看您的领奖信息，以免造成不便
            </div>
            <button
              type="button"
              className={cx(styles.layer47, styles.modalButton)}
              data-name="按钮-确定绑定"
              disabled={submitting}
              aria-busy={submitting}
              onClick={onConfirm}
            />
          </div>
          <button type="button" className={cx(styles.layer48, styles.modalButton)} data-name="弹窗-关闭按钮" onClick={onBack} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={cx(styles.group14, styles.visibleStateLayer)} data-name="弹窗-step:1:绑定角色">
        <div className={styles.layer28} data-name="弹窗-背景底框" />
        <div className={styles.layer29} data-name="绑定角色描述性文字">
          1.请先绑定角色后，点击“领取奖励”发放奖励；{'\n'}2. 一个账号只能绑定一个角色，绑定后不可换绑/解绑；{'\n'}3.
          本次活动奖励也将同步至绑定的角色，请谨慎选择。
        </div>
        <div className={styles.group15} data-name="弹窗-主体区域">
          <button
            type="button"
            className={cx(styles.layer30, styles.modalButton)}
            data-name="确定绑定按钮"
            aria-disabled={nextDisabled}
            aria-busy={submitting}
            onClick={onNext}
          />
          <div className={styles.group16} data-name="服务器&角色选定区">
            <div className={styles.group17} data-name="角色选择区">
              <Picker
                data={roles}
                value={selectedRoleId ? [selectedRoleId] : []}
                cols={1}
                disabled={rolePickerDisabled}
                onChange={value => onRoleChange && onRoleChange(value[0])}
              >
                <button type="button" className={cx(styles.group18, styles.modalButton)} data-name="选择角色下拉框区域" disabled={rolePickerDisabled}>
                  <div className={styles.layer31} data-name="下拉框区域及背景" />
                  {/* 2026-09-10 统一两个 picker 的文本层：与服务器侧同一套居中几何与双态配色，补齐「请选择角色」占位 */}
                  <span
                    className={cx(styles.pickerText, selectedRoleId && !loadingRoles ? styles.pickerTextSelected : styles.pickerTextPlaceholder)}
                    data-role="role-picker-text"
                  >
                    {loadingRoles ? '加载中' : getOptionLabel(roles, selectedRoleId) || '请选择角色'}
                  </span>
                  <div className={styles.layer32} data-name="倒三角下拉指示物" />
                </button>
              </Picker>
              <div className={styles.layer33} data-name="选择角色:">
                选择角色:
              </div>
            </div>
            <div className={styles.group19} data-name="服务器选择区">
              <Picker
                data={servers}
                value={selectedServerId ? [selectedServerId] : []}
                cols={1}
                disabled={serverPickerDisabled}
                onChange={value => onServerChange && onServerChange(value[0])}
              >
                <button type="button" className={cx(styles.group20, styles.modalButton)} data-name="服务器下拉框区域" disabled={serverPickerDisabled}>
                  <div className={styles.layer34} data-name="下拉框区域及背景" />
                  {/* layer35 为 PSD 锚点基线类；pickerText 组接管几何与双态配色（placeholder 浅色 / 选中加深） */}
                  <div
                    className={cx(
                      styles.layer35,
                      styles.pickerText,
                      selectedServerId && !loadingServers ? styles.pickerTextSelected : styles.pickerTextPlaceholder
                    )}
                    data-name="placeholder:请选择服务器"
                  >
                    {loadingServers ? '加载中' : getOptionLabel(servers, selectedServerId) || '请选择服务器'}
                  </div>
                  <div className={styles.layer36} data-name="倒三角下拉指示物" />
                </button>
              </Picker>
              <div className={styles.layer37} data-name="服务器:">
                服务器:
              </div>
            </div>
          </div>
        </div>
        <button type="button" className={cx(styles.layer38, styles.modalButton)} data-name="弹窗-关闭按钮" onClick={onClose} />
      </div>
    </div>
  );
};

export default MoRoleBinding;
